//react
import { useEffect, useState, useRef } from "react";
import { Link, useNavigate, useLocation, useParams } from "react-router-dom";

//css
import styled from "styled-components";
import { M, MMinus, MPlus, T } from "../../../utils/MT";

// img
import SearchSvg from "../../../assets/img/icon/icon_search.svg";

// componet
import BasicBtn from "../../../component/button/BasicBtn";

export default function NewPwd() {
    //페이지 이동
    const navigate = useNavigate();
    const nextPage = () => {
        navigate(`/newPwd/complete`);
    };

    // 비밀번호 찾기 액티브 스타일
    const [textActive1, setTextActive1] = useState(false);
    const [textActive2, setTextActive2] = useState(false);

    // 에러메세지
    const [error, setError] = useState(true);

    return (
        <Warp>
            <ContentWrap>
                <Title>
                    ENTER YOUR
                    <MbBr /> NEW PASSWORD
                </Title>
                <InputBigWrap>
                    <InputWrap marginActive={error == true ? true : false}>
                        <InputTitle>
                            <span>비밀번호</span>
                            <span>*</span>
                        </InputTitle>
                        <InputText
                            type="text"
                            placeholder="특수문자 포함 최소 8자 이상으로 조합하여 주세요."
                            active={textActive1.length > 0}
                            onChange={(e) => {
                                setTextActive1(e.target.value);
                            }}
                            required
                        />
                    </InputWrap>
                    {error && <ErrorText>*비밀번호가 조건에 맞지않습니다.</ErrorText>}
                    <InputWrap marginActive={error == true ? true : false}>
                        <InputTitle>
                            <span>비밀번호 확인</span>
                            <span>*</span>
                        </InputTitle>
                        <InputText
                            type="text"
                            placeholder="비밀번호를 입력해주세요."
                            active={textActive2.length > 0}
                            onChange={(e) => {
                                setTextActive2(e.target.value);
                            }}
                            required
                        />
                    </InputWrap>
                    {error && <ErrorText>*비밀번호가 일치하지않습니다.</ErrorText>}
                </InputBigWrap>
                <BtnWrap>
                    <BasicBtn onClick={nextPage} text="확인" />
                </BtnWrap>
            </ContentWrap>
        </Warp>
    );
}

const Warp = styled.div`
    position: relative;
    width: 100%;
    height: calc(100vh - 100vw * (140 / 1920));

    display: flex;
    align-items: center;
    justify-content: center;

    @media screen and (max-width: 1300px) {
        height: calc(100vh - 100vw * (140 / 1300));
    }

    @media screen and (max-width: 900px) {
        height: calc(100vh - 100vw * (51 / 428));
    }
`;

const ContentWrap = styled.div`
    width: calc(100vw * (700 / 1920));

    @media screen and (max-width: 1300px) {
        width: calc(100vw * (700 / 1300));
    }

    @media screen and (max-width: 900px) {
        width: ${M(378)};
    }
`;

const Title = styled.h2`
    font: calc(100vw * (50 / 1920)) "Pop-EL";
    text-align: center;

    margin-bottom: calc(100vw * (40 / 1920));

    @media screen and (max-width: 1300px) {
        font-size: calc(100vw * (50 / 1300));

        margin-bottom: calc(100vw * (40 / 1300));
    }

    @media screen and (max-width: 900px) {
        font-size: ${M(30)};
        text-align: center;

        margin-bottom: ${M(35)};
    }
`;

const InputBigWrap = styled.ul`
    margin: 0 auto calc(100vw * (20 / 1920));
    width: calc(100vw * (620 / 1920));

    @media screen and (max-width: 1300px) {
        width: calc(100vw * (620 / 1300));
        margin-bottom: calc(100vw * (20 / 1300));
    }

    @media screen and (max-width: 900px) {
        width: 100%;
        margin-bottom: ${M(35)};
    }
`;

const InputWrap = styled.li`
    display: flex;
    align-items: center;

    margin-bottom: calc(100vw * (20 / 1920));

    ${({ marginActive }) => {
        return (
            marginActive &&
            `
                margin-bottom: calc(100vw * (10 / 1920));
            `
        );
    }}

    @media screen and (max-width: 1300px) {
        margin-bottom: calc(100vw * (20 / 1300));

        ${({ marginActive }) => {
            return (
                marginActive &&
                `
            margin-bottom: calc(100vw * (10 / 1300));
        `
            );
        }}
    }

    @media screen and (max-width: 900px) {
        display: block;
        margin-bottom: ${M(15)};

        ${({ marginActive }) => {
            return (
                marginActive &&
                `
                    margin-bottom:${M(13)};
                `
            );
        }}
    }
`;

const InputTitle = styled.p`
    display: flex;
    align-items: center;

    width: calc(100vw * (110 / 1920));

    & span {
        font-size: calc(100vw * (15 / 1920));
    }
    & span:nth-child(2) {
        color: #ff5f00;
    }

    @media screen and (max-width: 1300px) {
        width: calc(100vw * (110 / 1300));

        & span {
            font-size: calc(100vw * (15 / 1300));
        }
    }

    @media screen and (max-width: 900px) {
        width: 100%;
        margin-bottom: ${M(10)};

        & span {
            font-size: ${M(14)};
        }
    }
`;

const InputText = styled.input`
    width: calc(100vw * (510 / 1920));
    font-size: calc(100vw * (15 / 1920));

    padding: calc(100vw * (11 / 1920)) calc(100vw * (15 / 1920));
    border-radius: 4px;

    ${({ active }) => {
        return active
            ? `
            border: 1px solid #FF5F00;
            background: #fff;
        `
            : `
            border: 1px solid #FAFAFA;
            background: #fafafa;
        `;
    }}

    @media screen and (max-width: 1300px) {
        width: calc(100vw * (510 / 1300));
        font-size: calc(100vw * (15 / 1300));

        padding: calc(100vw * (11 / 1300)) calc(100vw * (15 / 1300));
    }

    @media screen and (max-width: 900px) {
        width: 100%;

        font-size: ${M(14)};

        padding: ${M(12)} ${M(15)};
    }
`;
const BtnWrap = styled.div`
    width: calc(100vw * (180 / 1920));
    margin: 0 auto;

    @media screen and (max-width: 1300px) {
        width: calc(100vw * (180 / 1300));
    }

    @media screen and (max-width: 900px) {
        width: 100%;
    }
`;

const ErrorText = styled.p`
    font-size: calc(100vw * (14 / 1920));
    margin-bottom: calc(100vw * (10 / 1920));

    color: #ef0000;

    padding-left: calc(100vw * (110 / 1920));

    @media screen and (max-width: 1300px) {
        font-size: calc(100vw * (14 / 1300));
        margin-bottom: calc(100vw * (10 / 1300));

        padding-left: calc(100vw * (110 / 1300));
    }

    @media screen and (max-width: 900px) {
        font-size: ${M(13)};
        margin-bottom: ${M(13)};

        padding-left: 0;
    }
`;

const MbBr = styled.br`
    display: none;
    @media screen and (max-width: 900px) {
        display: block;
    }
`;
